import { render } from "./NonCurrentEtasView.vue?vue&type=template&id=0a6a3792&scoped=true"
import script from "./NonCurrentEtasView.vue?vue&type=script&lang=js"
export * from "./NonCurrentEtasView.vue?vue&type=script&lang=js"

import "./NonCurrentEtasView.vue?vue&type=style&index=0&id=0a6a3792&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6a3792"]])

export default __exports__